@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.placetype
import com.narbase.letsgo.dto.core.KmmLong

data class PlaceTypeDto(
    val id: KmmLong?,
    val nameAr: String?,
    val nameFr: String?,
    val nameEn: String?,
    val imageUrl: String?,
    val priority: Int,
)